const BOOKS_FOR_PAGE = 20;
const SERIES_FOR_PAGE = 40;
const TAGS_FOR_PAGE = 40;
const GENRES_FOR_PAGE = 40;
const AUTHORS_FOR_PAGE = 40;
const COLLECTIONS_FOR_PAGE = 10;
const PRERENDER_PAGES = 1;

const RUSSIAN_ALPHABET = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Э', 'Ю', 'Я'];
const ENGLISH_ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

const MENU_LINKS = [
  { name: 'Новинки книг', link: '/new_books' },
  { name: 'Аудиокниги', link: '/new_audioknigi' },
  { name: 'Вебтуны', link: '/webtoons' },
  { name: 'Списки', link: '/collections' },
  { name: 'Бесплатные книги', link: '/free_books' },
  { name: 'Отзывы', link: '/comments' },
  { name: 'Авторы', link: '/authors' },
  { name: 'Серии', link: '/serii-knig' },
  { name: 'Жанры', link: '/genres' },
  { name: 'Контакты', link: '/feedback' },
];

const config = {
  headers: {
    Accept: '/',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Authorization',
  },
};

const API_URL = `https://bookz.ru/api/v1/`;

const REVALIDATE_TIME = 300;

const CATEGORY_LINK = {
  books: 'Книги',
  authors: 'Авторы',
  genres: 'Жанры',
  series: 'Серии',
  tags: 'Тэги',
  drafts: 'Черновики',
  audio_books: 'Аудиокниги',
  podcasts: 'Подкасты',
};

const ABSOLUTE_URL = 'https://bookz.ru';
const DEV_ABSOLUTE_URL = '';
//Отображение картинок на dev
// const DEV_ABSOLUTE_URL = ABSOLUTE_URL;

const otherAuthorsBooksSliderConfig = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3500,
  initialSlide: 0,
  variableWidth: true,
  slidesToScroll: 1,
  slidesToShow: 4,
  swipe: false,
  responsive: [
    {
      breakpoint: 1060,
      settings: {
        swipe: true,
        arrows: false,
        touchThreshold: 1000000,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 530,
      settings: {
        swipe: true,
        arrows: false,
        slidesToShow: 1,
        slidesToSwipe: 1,
        touchThreshold: 1000000,
        swipeToSlide: true,
      },
    },
  ],
};

//LFROMS
const HEADER_BANNER_LFROM = '1256959353';
const BOOK_WIDGET_LFROM = '515850599';
const READER_WIDGET_LFROM = '389144085';
const BTN_DOWNLOAD_LFROM = '208630615';
const BTN_READ_ONLINE_LFROM = '1142890029';
const BTN_AUDIO_LFROM = '1176952624';
const FOOTER_LITRES_LFROM = '1258056584';
const PARTNER_BOOKS_LFROM = '1257096229';

const REG_EXP_WEB_LINK = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;

const READ_ONLINE_SECRET_KEY = process.env.READ_ONLINE_SECRET_KEY;

const SENTRY_SECRET_KEY = process.env.SENTRY_SECRET_KEY;

export {
  BOOKS_FOR_PAGE,
  SERIES_FOR_PAGE,
  GENRES_FOR_PAGE,
  AUTHORS_FOR_PAGE,
  COLLECTIONS_FOR_PAGE,
  RUSSIAN_ALPHABET,
  ENGLISH_ALPHABET,
  API_URL,
  PRERENDER_PAGES,
  config,
  REVALIDATE_TIME,
  CATEGORY_LINK,
  DEV_ABSOLUTE_URL,
  ABSOLUTE_URL,
  TAGS_FOR_PAGE,
  HEADER_BANNER_LFROM,
  BOOK_WIDGET_LFROM,
  READER_WIDGET_LFROM,
  BTN_DOWNLOAD_LFROM,
  BTN_READ_ONLINE_LFROM,
  BTN_AUDIO_LFROM,
  FOOTER_LITRES_LFROM,
  PARTNER_BOOKS_LFROM,
  MENU_LINKS,
  REG_EXP_WEB_LINK,
  READ_ONLINE_SECRET_KEY,
  SENTRY_SECRET_KEY,
  otherAuthorsBooksSliderConfig,
};
